import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    IdCuentaBancaria: { label: i18n.t('app.id'), value: '' },
    IBANAccountNumber: { label: i18n.t('invoices.invoices_issuing.iban'), value: '' },
    BIC: { label: i18n.t('invoices.invoices_issuing.bic_swift'), value: '' },
    SEPAIdentifier: { label: i18n.t('agenda.SEPA_Identifier'), value: '' },
    DefaultBankAccount: { label: i18n.t('agenda.default_bank_account'), value: '', type: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'IdCuentaBancaria', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'BankAccountAlias', width: '185px', title: i18n.t('invoices.invoices_issuing.nombre_cuenta'), columnMenu: 'myTemplate', locked: false },
    { field: 'IBANAccountNumber', width: '300px', title: i18n.t('invoices.invoices_issuing.iban'), columnMenu: 'myTemplate', locked: false },
    { field: 'BIC', width: '140px', title: i18n.t('invoices.invoices_issuing.bic_swift'), columnMenu: 'myTemplate', locked: false },
    { field: 'SEPAIdentifier', width: '170px', title: i18n.t('agenda.SEPA_Identifier'), columnMenu: 'myTemplate', locked: false },
    { 
      field: 'IdCifEmpresa', 
      title: i18n.t('companies.id_company'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      sortable: false,
      groupable: false,
      only: {
        roles: [7, 8, 3],
      },
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
